module.exports = __webpack_public_path__ + "img/38685-066.6a6b1a4c.jpg";